// extracted by mini-css-extract-plugin
export default {"header":"EmailRules_header__lbeUp","btnBox":"EmailRules_btnBox__umbqf","rulesBox":"EmailRules_rulesBox__-hlf3"};